import React, { useEffect, useMemo, useState } from "react";
import { useDatablockWidget } from "../../../hooks/mfn/useDatablockWidget";
import { Tabs, Tab } from "../../Common/Tabs";
import cn from "classnames";
import c from "../../../styles/container.module.scss";
import s from "./Datablock.ShareHolders.module.scss";
import ss from "./Datablock.SharedStyles.module.scss";
import tokens from "../tokens.json";

type Props = {
  locale: string;
  demo: boolean;
};

const ShareHolders: React.FC<Props> = ({ locale, demo }) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  const { initializeWidgets, cleanupWidgets } = useDatablockWidget();

  const widgetConfigs = useMemo(
    () => [
      {
        widget: "owner-list",
        widgetId: "owner-list",
        token: tokens.ownerList,
        label: locale === "en" ? "Owner list" : "Ägarlista",
      },
      {
        widget: "owner-country-dist",
        widgetId: "owner-country-dist",
        token: tokens.ownerCountryDist,
        label: locale === "en" ? "Country distribution" : "Land distribution",
      },
      {
        widget: "owner-holding-dist",
        widgetId: "owner-holding-dist",
        token: tokens.ownerHoldingDist,
        label:
          locale === "en" ? "Holding distribution" : "Innehav distribution",
      },
      {
        widget: "owner-type-dist",
        widgetId: "owner-type-dist",
        token: tokens.ownerTypeDist,
        label: locale === "en" ? "Type distribution" : "Typ distribution",
      },
      {
        widget: "owner-concentration",
        widgetId: "owner-concentration",
        token: tokens.ownerConcentration,
        label: locale === "en" ? "Concentration" : "Koncentration",
      },
    ],
    [locale]
  );

  useEffect(() => {
    initializeWidgets(widgetConfigs, locale, demo);
    return () => cleanupWidgets(widgetConfigs, locale);
  }, [locale, demo, widgetConfigs, initializeWidgets, cleanupWidgets]);

  return (
    <>
      <Tabs activeIndex={activeTab} alignment={"alignLeft"}>
        {widgetConfigs.map((tab, i) => (
          <Tab
            key={tab.widgetId}
            index={i}
            title={tab.label}
            isActive={activeTab === i}
            onClick={() => handleTabClick(i)}
          />
        ))}
      </Tabs>

      <div className={cn(ss.tabsWrapper, ss.contentWrapper)}>
        {widgetConfigs.map((tab, j) => (
          <div
            key={tab.widgetId}
            className={cn(ss.tab, { [ss.activeTab]: activeTab === j })}
          >
            <div
              id={`${tab.widgetId}-${locale}`}
              className={cn(c.xWide, s.shareholders)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ShareHolders;
